import { render, staticRenderFns } from "./SendBatch.vue?vue&type=template&id=4fb29236"
import script from "./SendBatch.vue?vue&type=script&lang=js"
export * from "./SendBatch.vue?vue&type=script&lang=js"
import style0 from "./SendBatch.vue?vue&type=style&index=0&id=4fb29236&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports